<template>
  <div class="row" :key="keyForm">
    <div v-for="(itemForm,idx) in listaDeFormularios[instanciaIdent]" :key="itemForm.id+'_'+idx" class="mb-5">
      
        <h2 class="form-title">{{ itemForm.dados.titulo }}</h2>

        <div :class="`${itemForm.dados.col || 'col-xs-12'}`">

          <div class="row">

            <template v-for="(listaDeCampos) in itemForm.dados.corpo">

              <TexInputComponent
                v-if="
                  listaDeCampos.type != 'hidden' &&
                  (listaDeCampos.type == 'text' ||
                  listaDeCampos.type == 'url' ||
                  listaDeCampos.type == 'textarea') &&
                  verificadorCondicional(listaDeCampos.show)
                "
                :name="listaDeCampos.name+'_field_'+idx"
                :type="listaDeCampos.type"
                :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                :validation="listaDeCampos.validation"
                :placeholder="listaDeCampos.placeholder"
                :class="listaDeCampos.col"
                :key="listaDeCampos.name+'_keytxtipt_'+idx"
                v-model="values[listaDeCampos.name+'_field_'+idx]"
                @update="inputCallback"
                @validation="verificadorDeValidacao"
                :validation-name="listaDeCampos.name"
                :readonly="!!(listaDeCampos.readonly || listaDeCampos.computed)"
              />
              <input v-else-if="
                  listaDeCampos.type == 'hidden' &&
                  listaDeCampos.type != 'text' &&
                  listaDeCampos.type != 'select' &&
                  listaDeCampos.type != 'textarea' &&
                  listaDeCampos.type != 'url' &&
                  verificadorCondicional(listaDeCampos.show)
                "
                :type="listaDeCampos.type"
                :name="listaDeCampos.name"
                :key="listaDeCampos.name+'_keyhiddentxtipt_'+idx"
                :value="values[listaDeCampos.name] = listaDeCampos.value"
              />

              <!-- <TexInputComponent
                v-else-if="
                  listaDeCampos.type == 'hidden' &&
                  verificadorCondicional(listaDeCampos.show)
                "
                :name="listaDeCampos.name+'_field_'+idx"
                :type="listaDeCampos.type"
                :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                :validation="listaDeCampos.validation"
                :placeholder="listaDeCampos.placeholder"
                :class="listaDeCampos.col"
                :key="listaDeCampos.name"
                v-model="values[listaDeCampos.name+'_field_'+idx]"
                @update="inputCallback"
                @validation="verificadorDeValidacao"
                :validation-name="listaDeCampos.name"
              /> -->
              <ComboboxInputComponent
                v-else-if="
                  listaDeCampos.type == 'select' &&
                  verificadorCondicional(listaDeCampos.show)
                "
                :name="listaDeCampos.name+'_field_'+idx"
                :type="listaDeCampos.type"
                :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                :options="listaDeCampos.options"
                :class="listaDeCampos.col"
                :key="listaDeCampos.name+'_keycbb_'+idx"
                v-model="values[listaDeCampos.name+'_field_'+idx]"
                @update="inputCallback"
                @validation="verificadorDeValidacao"
                :validation-name="listaDeCampos.label"
              ></ComboboxInputComponent>

              <AutocompleteComponent
                v-else-if="
                  listaDeCampos.type == 'autocomplete' &&
                  verificadorCondicional(listaDeCampos.show)
                "
                :name="listaDeCampos.name+'_field_'+idx"
                :type="listaDeCampos.type"
                :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                :options="listaDeCampos.options"
                :class="listaDeCampos.col"
                :key="`autocomplete_${listaDeCampos.name}_${itemForm.id}_${listaDeCampos.options.length}`"
                v-model="values[listaDeCampos.name+'_field_'+idx]"
                @update="inputCallback"
                @validation="verificadorDeValidacao"
                :validation="listaDeCampos.validation"
                :validation-name="listaDeCampos.name"
                :loading="listaDeCampos.options == 0"
                
              ></AutocompleteComponent>

              <RadioInputComponent
                v-else-if="listaDeCampos.type == 'radio'"
                :name="listaDeCampos.name+'_field_'+idx"
                :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                :options="listaDeCampos.options"
                :class="listaDeCampos.col"
                :validation="listaDeCampos.validation"
                :key="'radio_'+listaDeCampos.name+'_'+itemForm.id"
                v-model="values[listaDeCampos.name+'_field_'+idx]"
                @update="inputCallback"
                @validation="verificadorDeValidacao"
                :validation-name="listaDeCampos.label"
              >
              </RadioInputComponent>

              <DateInputComponent
                v-else-if="
                  (listaDeCampos.type == 'date' ||
                  listaDeCampos.type == 'time' ||
                  listaDeCampos.type == 'datetime-local') &&
                  listaDeCampos.type != 'url' &&
                  verificadorCondicional(listaDeCampos.show)
                "
                :name="listaDeCampos.name+'_field_'+idx"
                :type="listaDeCampos.type"
                :label="`${listaDeCampos.label} ${inputEhObrigatorio(listaDeCampos.validation)}`"
                :validation="listaDeCampos.validation"
                :placeholder="listaDeCampos.placeholder"
                :class="listaDeCampos.col"
                :key="listaDeCampos.id+'_keydateipt_'+idx"
                v-model="values[listaDeCampos.name+'_field_'+idx]"
                @update="inputCallback"
                @validation="verificadorDeValidacao"
                :validation-name="listaDeCampos.label"
              />

            </template>

            <span v-if="!multiplo">
              <div class="col">
                <ButtonComponent v-if="exportarDados" type="button" @salvarFormularioDinamico="exibeValue()" label="Salvar" />
              </div>
              <div class="col text-right"><small>Campos com * são obrigatórios.</small></div>
            </span>
          </div>

        </div>
    
      <!-- </FormulateForm> -->
    </div>
    <span v-if="multiplo">
      <div class="col">
        <ButtonComponent v-if="exportarDados" type="button" @salvarFormularioDinamico="exibeValue()" label="Salvar" />
      </div>
      <div class="col text-right"><small>Campos com * são obrigatórios.</small></div>
    </span>
    <SGPLoadingComponent v-if="loadingFormularios" />
  </div>
</template>

<script>
import Vue from 'vue';
import '@/assets/css/formulate.css';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import VueFormulate from '@braid/vue-formulate';
import { pt } from '@braid/vue-formulate-i18n';
import ButtonComponent from './ButtonComponent.vue';
import TexInputComponent from './TexInputComponent.vue';
import RadioInputComponent from './RadioInputComponent.vue';
import ComboboxInputComponent from './ComboboxInputComponent.vue';
import DateInputComponent from './DateInputComponent.vue';
import AutocompleteComponent from './AutocompleteComponent.vue';

import EventBus from '@/common/helpers/EventBus'

import HttpClient from '@/common/boot/HttpClient'
import criarToast from '@/common/boot/ToastsHandler'
import { processarCampoComputado, criarMapaDependencias } from '@/modules/workflow/forms/ctrl-formularios-dinamicos/service/CamposComputadosService'
// import { recuperarCookie } from '@/common/boot/CookiesHandler.js';

Vue.use(VueFormulate, {
  classes: {
    inputHasErrors: 'is-invalid',
    errors: 'list-unstyled text-danger',
  },
  locale: 'pt',
  plugins: [pt]
});


export default {
  components: {
    RadioInputComponent,
    ButtonComponent,
    TexInputComponent,
    ComboboxInputComponent,
    DateInputComponent,
    AutocompleteComponent
  },

  name: 'RenderizaFormularioComponent',

  props: {
    instanciaIdent: {
      type: String,
      required: false,
      default: 'instancia1'
    },

    arrayFormId: {
      type: Array,
      required: false
    },

    formulario_id: {
      type: Number,
      required: false
    },

    acaoFormulario: {
      type: String,
      required: false,
      default: 'cadastrar'
    },

    endpoint: {
      type: String,
      required: false,
      default: () => ''
    },

    exportarDados: {
      type: Boolean,
      required: false,
      default: false
    },

    multiplo: {
      type: Boolean,
      required: false,
      default: false
    },

    identificador: {
      type: String,
      required: false,
      default: null
    }
  },

  data () {
    return {
      values: {},
      gatilhos: [],
      validation: [],
      errosValidacao: {},
      keyForm: false,
      mapaDependencias: {}
    }
  },

  async created() {
    console.log('🟡 [OLD COMPONENT] created()')
    let paramFormsId = (typeof this.$props.formulario_id != 'undefined') ? 
                      [this.$props.formulario_id] : this.$props.arrayFormId;  

    console.log('🟡 [OLD COMPONENT] Form IDs:', paramFormsId)
    await this.renderizarFormulario({instanciaIdent: this.instanciaIdent, formulariosId: paramFormsId});
    console.log('🟡 [OLD COMPONENT] Formulários carregados:', this.listaDeFormularios)
    
    await this.setarVariaveisDoFormulario()
    console.log('🟡 [OLD COMPONENT] Após setarVariaveisDoFormulario, values:', this.values)
    
    this.criarMapaDependenciasCampos()
    this.processarCamposComputados()
    console.log('🟡 [OLD COMPONENT] Após processarCamposComputados, values:', this.values)
    // this.apontarGatilhos()
    // await this.fabricaDeRequisicoes()

    EventBus.$on('rederizaFormularioNovamente', this.reRenderForm)
  },

  destroyed () {
    EventBus.$off('rederizaFormularioNovamente');
  },

  mounted () {
    console.log('🔵 [OLD COMPONENT] mounted()')
    this.validation = [];

    /*
     Esse trexho abaixo verifica se existe algum formulario salvo em cache
     e tenta preencher o formulário com os dados salvos em cache
     OBS: os dados salvos em cache são salvos em formato de JSON.stringfy */
    const cacheKey = process.env.VUE_APP_FORMULARIO_DINAMICO_MINIMIZADO + '' +((this.identificador != null) ? `_${this.identificador}` : '')
    console.log('🔵 [OLD COMPONENT] Cache key:', cacheKey)
    const cacheValue = localStorage.getItem(cacheKey)
    console.log('🔵 [OLD COMPONENT] Cache value:', cacheValue)
    
    if (cacheValue) {
      try {
        const formulario = JSON.parse(cacheValue)
        console.log('🔵 [OLD COMPONENT] Formulário do cache:', formulario)
        if (formulario && Object.keys(formulario).length) {
          this.values = formulario.values ? formulario.values : {}
          console.log('🔵 [OLD COMPONENT] ⚠️ Values sobrescritos do cache:', this.values)
          // Reprocessar campos computados após carregar do cache
          this.processarCamposComputados()
        }
      } catch (e) {
        console.error('🔵 [OLD COMPONENT] Erro ao parsear cache:', e)
      }
    } else {
      console.log('🔵 [OLD COMPONENT] Sem cache, mantendo values atuais')
    }
  },

  computed: {
    ...mapGetters('formularios', ['loadingFormularios', 'listaDeFormularios'])
  },

  methods: {
    ...mapActions('formularios', ['renderizarFormulario', 'inserirOptions', 'salvarDadosFormulario']),
    ...mapMutations('formularios', ['INSERIR_FORM_VALUES']),

    reRenderForm () {
      this.keyForm = !this.keyForm
    },

    inputEhObrigatorio(validation) {
      if (!validation) return ''

      if (validation.includes('nullable')) return ''

      return '*'
    },

    verificadorDeValidacao(event) {
      const hasInput = this.validation.find(input => input.name === event.name) || false;
      if(!hasInput) {
        this.validation.push(event)
      } else {
        this.validation = this.validation.map(input => {
          if(input.name === event.name) {
            input = event
          }
          return input 
        })
      }
    },

    verificaSeNomeEIgualCampoForm(campoErroName) {
      let index = 0;
      let reallyHasError = false;
      this.listaDeFormularios[this.instanciaIdent].forEach(form => {
        form.dados.corpo.forEach(listaDeCampos => {
          if(campoErroName === listaDeCampos.name+'_field_'+index) {
            reallyHasError = true;
          }
        });
        ++index;
      });
      return reallyHasError;
    },

    existeCampoComErroDeValidacao() {
      let reallyHasError = false;
      if (this.validation.length) {
        const hasError = this.validation.find(input => input.hasErrors === true);

        if (hasError){
          reallyHasError = this.validation.find(input => this.verificaSeNomeEIgualCampoForm(input.name));
        }
      }
      return reallyHasError;
    },

    async setarVariaveisDoFormulario () {
      if (this.listaDeFormularios.length == 0) {
        return false;
      }

      let index = 0;

      this.listaDeFormularios[this.instanciaIdent].forEach( form => {
        const corpoForm = form.dados.corpo
        corpoForm.forEach(item => {
          this.values[item.name+'_field_'+index] = item.value || '';
        })
        ++index;
      })
      return true;
    },

    inputCallback (val) {
      console.log('🟢 [OLD COMPONENT] inputCallback - val:', val)
      if (!val || !val.name) {
        console.log('🟢 [OLD COMPONENT] ⚠️ Val inválido!')
        return
      }

      const valorCopiado = { ...this.values }
      valorCopiado[val.name] = val.model
      this.values = valorCopiado
      console.log('🟢 [OLD COMPONENT] Values após update:', this.values)

      // Extrair nome do campo sem o sufixo _field_X
      const nomeCampoLimpo = val.name.split('_field_')[0]
      console.log('🟢 [OLD COMPONENT] Nome campo limpo:', nomeCampoLimpo)
      this.atualizarCamposComputadosDependentes(nomeCampoLimpo)
    },

    exibeValue () {
      if (this.exportarDados) {
        // if (this.existeCampoComErroDeValidacao()) {
        //   this.mostraMessagemErroValidacao()
        //   return
        // }
        let dadosPorformularios = [];
        let dados;
        let index = 0;
        this.listaDeFormularios[this.instanciaIdent].forEach(form => {
          dados = {};
          dados['ctrl_formulario_id'] = form.dados.id;
          dados['ctrl_tarefa_id'] = form.ctrl_tarefa_id;
          form.dados.corpo.forEach(listaDeCampos => {
            if ( listaDeCampos.type.includes('hidden') ||
              (typeof this.values[listaDeCampos.name+'_field_'+index] != 'undefined' &&
             this.values[listaDeCampos.name+'_field_'+index] != '')) {
              dados[listaDeCampos.name] = this.values[listaDeCampos.name+'_field_'+index];
            }
          })
          dadosPorformularios.push(dados);
          ++index;
        })

        let valores = this.limparIndicesObj();

        this.$emit('dadosFormularioDinamicoEmit', {
          values: {
            ...valores
          },
          formularios: this.listaDeFormularios[this.instanciaIdent],
          dadosPorformularios: dadosPorformularios
        });

        criarToast({
          tipo: 'success',
          mensagem: 'Formulário salvo com sucesso!'
        })

        return
      }

      if(this.endpoint) {
        this.salvarDadosFormulario(this.values, this.endpoint)
      }
    },

    limparIndicesObj () {
      console.log('🧹 [OLD COMPONENT] limparIndicesObj - values originais:', this.values)
      let valores = {};
      for (const indice in this.values) {
        const novoIndice = indice.split('_field_');
        valores[novoIndice[0]] = this.values[indice];
      }
      console.log('🧹 [OLD COMPONENT] Valores limpos:', valores)
      return valores;  
    },

    verificadorCondicional (val) {
      return eval(val)
    },

    apontarGatilhos () {
      this.listaDeFormularios[this.instanciaIdent].forEach(form => {
        form.dados.corpo.forEach(item => {
          if (item.requisicao) {
            if(!this.gatilhos.includes(item.requisicao.gatilho)) {
              this.gatilhos.push(item.requisicao.gatilho)
            }
          }
        })
      })
    },

    mostraMessagemErroValidacao () {
      criarToast({
        tipo: 'error',
        mensagem: 'Há campos obrigatórios não preenchidos, por favor verifique antes de salvar.'
      })
    },

    criarMapaDependenciasCampos() {
      console.log('🗺️ [OLD COMPONENT] criarMapaDependenciasCampos')
      if (!this.listaDeFormularios || !this.listaDeFormularios[this.instanciaIdent]) {
        console.log('🗺️ [OLD COMPONENT] ⚠️ Sem formulários!')
        return;
      }

      // Coletar todos os campos de todos os formulários
      const todosCampos = [];
      this.listaDeFormularios[this.instanciaIdent].forEach(form => {
        if (form.dados && form.dados.corpo) {
          console.log('🗺️ [OLD COMPONENT] Form corpo:', form.dados.corpo)
          todosCampos.push(...form.dados.corpo);
        }
      });

      console.log('🗺️ [OLD COMPONENT] Total campos:', todosCampos.length)
      this.mapaDependencias = criarMapaDependencias(todosCampos);
      console.log('🗺️ [OLD COMPONENT] Mapa criado:', this.mapaDependencias)
    },

    processarCamposComputados() {
      console.log('🟣 [OLD COMPONENT] processarCamposComputados')
      if (!this.listaDeFormularios || !this.listaDeFormularios[this.instanciaIdent]) {
        console.log('🟣 [OLD COMPONENT] ⚠️ Sem formulários!')
        return;
      }

      let index = 0;
      this.listaDeFormularios[this.instanciaIdent].forEach(form => {
        if (form.dados && form.dados.corpo) {
          form.dados.corpo.forEach(campo => {
            console.log('🟣 [OLD COMPONENT] Verificando campo:', campo.name, '| computed:', campo.computed)
            if (campo.computed && campo.computed.format) {
              console.log('🟣 [OLD COMPONENT] ✅ Campo computado encontrado:', campo.name)
              // Cria um objeto temporário com valores limpos (sem _field_X)
              const valoresLimpos = this.limparIndicesObj();
              console.log('🟣 [OLD COMPONENT] Valores limpos:', valoresLimpos)
              const valorComputado = processarCampoComputado(campo, valoresLimpos);
              console.log('🟣 [OLD COMPONENT] Valor computado:', valorComputado)
              console.log('🟣 [OLD COMPONENT] Setando em:', campo.name + '_field_' + index)
              this.$set(this.values, campo.name + '_field_' + index, valorComputado);
              console.log('🟣 [OLD COMPONENT] Values após set:', this.values)
            }
          });
        }
        ++index;
      });
      console.log('🟣 [OLD COMPONENT] ✅ Processamento completo. Values final:', this.values)
    },

    atualizarCamposComputadosDependentes(nomeCampo) {
      console.log('🔶 [OLD COMPONENT] atualizarCamposComputadosDependentes - campo:', nomeCampo)
      const camposDependentes = this.mapaDependencias[nomeCampo] || [];
      console.log('🔶 [OLD COMPONENT] Campos dependentes:', camposDependentes)
      
      if (camposDependentes.length === 0) {
        console.log('🔶 [OLD COMPONENT] ⚠️ Nenhum dependente!')
        return;
      }

      camposDependentes.forEach(nomeCampoDependente => {
        console.log('🔶 [OLD COMPONENT] Processando dependente:', nomeCampoDependente)
        // Encontrar o campo dependente em todos os formulários
        let index = 0;
        this.listaDeFormularios[this.instanciaIdent].forEach(form => {
          if (form.dados && form.dados.corpo) {
            const campoDependente = form.dados.corpo.find(c => c.name === nomeCampoDependente);
            console.log('🔶 [OLD COMPONENT] Campo encontrado:', campoDependente)
            
            if (campoDependente && campoDependente.computed) {
              console.log('🔶 [OLD COMPONENT] ✅ É computado! Processando...')
              // Cria um objeto com valores limpos para processamento
              const valoresLimpos = this.limparIndicesObj();
              console.log('🔶 [OLD COMPONENT] Valores limpos:', valoresLimpos)
              const valorComputado = processarCampoComputado(campoDependente, valoresLimpos);
              console.log('🔶 [OLD COMPONENT] Valor computado:', valorComputado)
              console.log('🔶 [OLD COMPONENT] Setando em:', campoDependente.name + '_field_' + index)
              
              // Atualizar usando object spread para garantir reatividade
              this.values = {
                ...this.values,
                [campoDependente.name + '_field_' + index]: valorComputado
              };
              console.log('🔶 [OLD COMPONENT] Values após set:', this.values)
            }
          }
          ++index;
        });
      });
    },

    async dispararGatilhosAoCarregar() {
      if (this.listaDeFormularios) {
        await this.listaDeFormularios[this.instanciaIdent].forEach(form => {
          const bodyFormulario = form.dados.corpo
          bodyFormulario.forEach(async input => {          
            if (input.requisicao && input.requisicao.gatilho == 'load') {
              await this.fabricaDeRequisicoes(input.requisicao.gatilho)
            }
          })
        })
      }
    },

    fabricaDeRequisicoes (gatilho = 'load') {
      if (!this.listaDeFormularios[this.instanciaIdent][0]?.dados.corpo) {
        return
      }

      this.listaDeFormularios[this.instanciaIdent].forEach(form => {
        form.dados.corpo.forEach(async item => {
          if (item.requisicao) {
            
            if (item.requisicao.gatilho !== gatilho ) {
              return 
            }

            const itemOptions = [{
              label: 'Selecione',
              value: ''
            }]

            let response = {}

            if (gatilho == 'load') {
              response = await HttpClient({ method: item.requisicao.metodo, url: item.requisicao.endpoint});
            } else {
              // habilitar requisições com parametros via url
              response = await HttpClient({ method: item.requisicao.metodo, url: item.requisicao.endpoint});
            }         
          
            if (response.status == 200) {
              response.data.data.forEach(respItem => {
                const objOption = {
                  label: respItem[item.requisicao.optionLabel],
                  value: respItem[item.requisicao.optionValue]
                }              
                itemOptions.push(objOption)
              })

              this.inserirOptions({ instanciaIdent: this.instanciaIdent, name: item.name, options: itemOptions})
            }
          }
        })
      })
    }

  },

  watch: {
    values (newValue, oldValue) {
      if (newValue != oldValue) {
        this.$emit('dadosPreenchidosNoFormularioDinamico', {...JSON.parse(JSON.stringify(newValue))});
      }
      
      for(const keyValue in newValue) {

        if(this.gatilhos.includes(keyValue)) {          

          if(newValue[keyValue] !== oldValue[keyValue]) {
             this.fabricaDeRequisicoes(keyValue)
          }
        }
      }

      if(this.exportarDados) {
        this.$emit('dadosAoAtualizarFormularioEmit', { 
          values: newValue,
          config: this.listaDeFormularios[0],
          configArray: this.listaDeFormularios
        });
      }

    },

    'this.listaDeFormularios[this.instanciaIdent][0].id' () {
      this.validation = []
    }
  }
};
</script>

<style scoped>

.login-form {
  padding: 2em;
  border: 1px solid #a8a8a8;
  border-radius: 0.5em;
  max-width: 80%;
  box-sizing: border-box;
  margin: auto;
}

.form-title {
  margin-top: 0;
}

.login-form::v-deep .formulate-input .formulate-input-element {
  max-width: none;
}

@media (min-width: 420px) {
  .double-wide {
    display: flex;
  }
  .double-wide .formulate-input {
    flex-grow: 1;
    width: calc(50% - 0.5em);
  }
  .double-wide .formulate-input:first-child {
    margin-right: 0.5em;
  }
  .double-wide .formulate-input:last-child {
    margin-left: 0.5em;
  }

  .mdn-Icon-claro {
    margin: auto;
  }
}
</style>